export function isSessionSelectable(session) {
  return session.status === 'AVAILABLE';
}

export function generateConfirmationId() {
  const now = Date.now().toString(36).toUpperCase();
  const rand = Math.random().toString(36).slice(2, 8).toUpperCase();
  return `RR-${now}-${rand}`;
}

export function buildRegistrationSummary(state) {
  const selectedStudents = state.students.filter((s) => state.selectedStudentIds.includes(s.id));
  const selectedSessions = state.selectedSessions || [];

  const assignments = selectedStudents.map((student) => {
    const studentSessionIds = state.studentSessionAssignments[student.id] || [];
    return {
      student,
      sessions: selectedSessions.filter((s) => studentSessionIds.includes(s.id))
    };
  });

  return {
    isFree: true,
    center: null, // Will be fetched from API when needed
    retreat: null, // Will be fetched from API when needed
    selectedSessions,
    selectedStudents,
    assignments
  };
}
